// extracted by mini-css-extract-plugin
var _1 = "webpack-components-FullTextBulkUploader-components-DragAndDropUploader-module__UploaderSection";
var _2 = "webpack-components-FullTextBulkUploader-components-DragAndDropUploader-module__fileInputDragEnter";
var _3 = "webpack-components-FullTextBulkUploader-components-DragAndDropUploader-module__input";
export { _1 as "UploaderSection", _2 as "fileInputDragEnter", _3 as "input" }
